export class EasyCrypto {
	isSupported() {
		return (
			window.crypto &&
			window.Promise &&
			// not really polyfillable
			window.File &&
			window.FileReader &&
			window.ArrayBuffer &&
			window.DataView &&
			(window.TextEncoder || window.Uint8Array)
		);
	}

	digest(algo, stringOrFileOrBuffer) {
		if (stringOrFileOrBuffer instanceof File) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = () => {
					const arrayBuffer = reader.result;
					this.digest(algo, arrayBuffer).then(resolve, reject);
				};
				reader.onerror = reject;
				reader.readAsArrayBuffer(stringOrFileOrBuffer);
			});
		}
		if (typeof stringOrFileOrBuffer == 'string') {
			stringOrFileOrBuffer = this.stringToBuffer(stringOrFileOrBuffer);
		}
		if (stringOrFileOrBuffer instanceof ArrayBuffer || stringOrFileOrBuffer instanceof Uint8Array) {
			if (!crypto.subtle) {
				console.error('Error: crypto.subtle is not defined. Is this URL https? Is this an old browser?');
				return;
			}
			return crypto.subtle.digest(algo, stringOrFileOrBuffer).then(this.bufferToHex);
		}
		throw new Error('easyCrypto.digest(value): value must be a string, File, ArrayBuffer or ArrayBufferView.');
	}

	sha256(stringOrFileOrBuffer) {
		return this.digest('SHA-256', stringOrFileOrBuffer);
	}

	sha384(stringOrFileOrBuffer) {
		return this.digest('SHA-384', stringOrFileOrBuffer);
	}

	sha512(stringOrFileOrBuffer) {
		return this.digest('SHA-512', stringOrFileOrBuffer);
	}

	stringToBuffer(str) {
		if (window.TextEncoder) {
			return new TextEncoder('utf-8').encode(str);
		}
		// IE 11
		const utf8 = unescape(encodeURIComponent(str));
		const result = new Uint8Array(utf8.length);
		for (let i = 0; i < utf8.length; i++) {
			result[i] = utf8.charCodeAt(i);
		}
		return result;
	}

	bufferToHex(buffer) {
		const hexCodes = [];
		const view = new DataView(buffer);
		for (let i = 0; i < view.byteLength; i += 4) {
			// Using getUint32 reduces the number of iterations needed (we process 4 bytes each time)
			const value = view.getUint32(i);
			// toString(16) will give the hex representation of the number without padding
			const stringValue = value.toString(16);
			// We use concatenation and slice for padding
			const padding = '00000000';
			const paddedValue = (padding + stringValue).slice(-padding.length);
			hexCodes.push(paddedValue);
		}
		// Join all the hex strings into one
		return hexCodes.join('');
	}

	randomString(length, alphabet = 'bcdfghjklmnpqrstvwxz23456789') {
		const ints = new Uint8Array(length);
		window.crypto.getRandomValues(ints);
		const letters = Array.from(ints, idx => alphabet.charAt(idx % alphabet.length));
		return letters.join('');
	}
}

export const easyCrypto = new EasyCrypto();
